<template>
    <v-container>
        <v-row>
            <v-col cols="12" md="3">
                <v-select
                    v-model="selectedEvent"
                    :items="events"
                    item-text="name"
                    item-value="id"
                    :disabled="isLoading"
                    label="Event"
                    outlined
                    dense
                    hide-details
                ></v-select>
            </v-col>
        </v-row>
        <div class="my-3 font-weight-bold text-h6">Rumour Documents</div>
        <v-row>
            <v-col cols="12" md="2">
                <v-checkbox v-model="includeUnapproved" label="Include Unapproved?" class="mt-1"></v-checkbox>
            </v-col>
            <v-col>
                <v-btn @click="getRumoursDoc" :disabled="!selectedEvent || isLoading">Download Rumours</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import api from '@/api'
import { mapState, mapGetters } from 'vuex'
export default {
    name: 'EncounterPrint',
    data() {
        return {
            isLoading: false,
            selectedEvent: 0,
            includeUnapproved: false,
        }
    },
    computed: {
        ...mapState(['user']),
        ...mapGetters(['events', 'nextEvent', 'currentEvent', 'userTeams']),
        event() {
            if (!this.selectedEvent || !this.events || this.events.length === 0) return
            let event = this.events.find(x => x.id === this.selectedEvent)
            return event
        },
    },
    mounted() {
        if (this.currentEvent) {
            this.selectedEvent = this.currentEvent
        }
    },
    methods: {
        getRumoursDoc() {
            if (this.selectedEvent === 0) return
            this.isLoading = true
            var query = ''
            if (this.includeUnapproved) {
                query = `includeUnapproved=true`
            }
            api.client
                .get(`/rumours/print/${this.selectedEvent}${query ? `?${query}` : ``}`, {
                    responseType: 'blob',
                })
                .then(res => {
                    const blob = new Blob([res.data], { type: res.data.type })
                    let contentDisposition = res.headers['content-disposition']
                    let match = contentDisposition.match(/filename\s*=\s*"?(.+)"?;/i)
                    let filename = match[1]
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = filename
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                })
                .finally(() => (this.isLoading = false))
        },
        eventChange() {
            this.$store.commit('setCurrentEvent', this.selectedEvent)
        },
    },
}
</script>
